import Big from 'big.js';
export function toThousands(num) {  // 超过3位数字的用逗号显示
  var str = num;
  var num = (num || 0).toString().replace(/[^\d|.]/g, ''),
　　　result = '';
  //判断是否带小数点
　　if (num.split('.')[1]) {
　　　　var numInt = num.split('.')[0],
　　　　numFlo = num.split('.')[1];
　　　　result = formatter(numInt) + '.' + numFlo
　　} else {
　　　　result = formatter(num);
　　}
　　return result;

//格式化整数
　　function formatter(numInt) {
　　　　var resultInt = '';
　　　　while (numInt.length > 3) {
　　　　　　resultInt = ',' + numInt.slice(-3) + resultInt;
　　　　　　numInt = numInt.slice(0, numInt.length - 3);
　　　　}
　　　　if (numInt) {
　　　　　　resultInt = numInt + resultInt;
　　　　}
		if(str<0) {
			return  '-'+resultInt;
		} else {
　　　　   return resultInt;
		}
　　}
}

export function floatNumber(num,count){
  return parseInt(num*Math.pow(10,count))/Math.pow(10,count)+'';
}
// 改造floatNumber适应js科学计数法问题
export function floatNumberss(num,count){
    if (num-0<0.00001) {
        if (num.length<=9&&num-0>0.0000001) {
            return num
        }else{
            return 0
        }
    }else{
        num = num-0
        return parseInt(num*Math.pow(10,count))/Math.pow(10,count)+'';
    }
  }
export function toFixed(num,count){
  return parseFloat(num).toFixed(count);
}
//国际化时间去掉时分秒
export function deleteTime (date, day) {
  if (date) {
    const time = new Date(date)
    if (time == 'Invalid Date') {
      const arr = date.split(",")
      const mouth = arr[1]
      const year = arr[2]
      const one = new Date(year).getFullYear()
      const two = new Date(mouth).getMonth()
      const three = new Date(mouth).getDate()
      return two+ "-" + one  + "-" + three;
    }
    if (day) {
      var dateTime = (new Date(date)).getTime();
      var diffTimeLong = dateTime + (day) * 24 * 3600 * 1000;
      var diffTime = new Date(diffTimeLong);
      var m = (diffTime.getMonth() + 1) < 10 ? "0" + (diffTime.getMonth() + 1) : (diffTime.getMonth() + 1);
      var d = diffTime.getDate() < 10 ? "0" + diffTime.getDate() : diffTime.getDate();
      return diffTime.getFullYear() + "-" + m + "-" + d;
    }
    return  (time.getMonth() + 1) + "-" + time.getDate() + "-" +time.getFullYear();
  } else {
    return date
  }

}
// 标准时间排列

export function timeCriterion (date, day) {
  if (date) {
    const time = new Date(date)
    if (time == 'Invalid Date') {
      const arr = date.split(",")
      const mouth = arr[1]
      const year = arr[2]
      const H = arr[0]
      const y = new Date(year).getFullYear()
      const m = new Date(mouth).getMonth()
      const d = new Date(mouth).getDate()
      return  m + "-" + d  + "-"+ y + " "  +  H;
    }
    if (day) {
      var dateTime = (new Date(date)).getTime();
      var diffTimeLong = dateTime + (day) * 24 * 3600 * 1000;
      var diffTime = new Date(diffTimeLong);
      var m = (diffTime.getMonth() + 1) < 10 ? "0" + (diffTime.getMonth() + 1) : (diffTime.getMonth() + 1);
      var d = diffTime.getDate() < 10 ? "0" + diffTime.getDate() : diffTime.getDate();
      return  m + "-" + d + "-" + diffTime.getFullYear() ;
    }
    var m = (time.getMonth() + 1) < 10 ? "0" + (time.getMonth() + 1) : (time.getMonth() + 1);
    var d = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
    return  m + "-" + d + "-"  + time.getFullYear()  ;
  } else {
    return date
  }

}



// 对银行卡进行加密
export function bankCard(card){
  //取银行卡号后四位
  if (card && card.length > 8) {
    const cardConcel = "*****" + card.substring(card.length - 4);
    return cardConcel
  }else if (card && (card.length > 0 && card.length < 6 )){
    const cardConcel =card.substring(card.length - 4);
    return cardConcel
  }
  else{
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/filters/index.js